import { Component, Input, EventEmitter, Output, OnInit, NgZone } from '@angular/core';
import { UserData } from '../../providers/user-data';
import { ParkbewilligungenData, PbActions } from '../../pages/parkbewilligungen/parkbewilligungen-data';
import { CommonData } from '../../providers/common-data';
import { AdditionalfieldsData } from '../../providers/additionalfields-data';

/**
 * Generated class for the AdditionalfieldsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'additionalfields',
  templateUrl: 'additionalfields.html'
})
export class AdditionalfieldsComponent {
  private _table;
  @Input('table') 
  get table(): string {
    return this._table;
  }
  set table(value: string) {
    this._table = value;
    if(this._table && this._recordid){
      this.refreshDetails();
    }    
  }    

  private _recordid;
  @Input('recordid') 
  get recordid(): number {
    return this._recordid;
  }
  set recordid(value: number) {
    this._recordid = value;
    if(this._table && this._recordid){
      this.refreshDetails();
    }    
  }    

  private _readonly = true;
  @Input('readonly') 
  get readonly(): boolean {
    return this._readonly;
  }
  set readonly(value: boolean) {
    this._readonly = "" + value !== "false";
  }    


  @Output() onChange: EventEmitter<any> = new EventEmitter<any>();

  private additionalfields;

  constructor(
    public userData: UserData
    ,public pbData: ParkbewilligungenData
    ,public afData: AdditionalfieldsData
    , public common: CommonData
    , public zone: NgZone
  ) 
  {
      this.additionalfields = [];
  }

  refreshDetails(){      
    //pd.period.edited = "changed";
    this.zone.run(() => {      
      if(this.additionalfields){
        this.additionalfields.length = 0;
      }
      this.afData.loadfields(this._table, this._recordid).then(res => {
        if(res){
          this.additionalfields = res;
        }
      });            
    });    
    
  }


  afChanged(event, af,afindex){
    
    if(!this.additionalfields[afindex].edited){
      this.additionalfields[afindex].edited="changed";
    }

    if(this.onChange){
      this.onChange.emit();
    }
    
  }  

  addField(){
    if(!this.additionalfields){
      this.additionalfields = [];
    }
    this.additionalfields.push({edited:"added", name:"", typ:"text", description:"", required:1, position:this.additionalfields.length+1})
    this.afChanged(null, this.additionalfields[this.additionalfields.lenght-1], this.additionalfields.length-1);
  }

  discardChanges(){
    this.refreshDetails();
  }
  updateChanges(){
    this.afData.updateAdditionalfields(this._table, this._recordid, this.additionalfields).then(res => {
      this.additionalfields = res;
    });        
  }
  removeAdditionalfield(af, afindex){
    if(af.edited && af.edited == "removed"){
     delete af.edited;
    }
    else if(af.edited && af.edited == "added"){
     this.additionalfields.splice(afindex,1);
    }
    else{
      //console.log('remove rule');
      //console.log(this.additionalfields[afindex]);
      this.additionalfields[afindex].edited="removed";
      this.afChanged(null, af, afindex);
    }
  }

  validate(){
    //-- Check leere Namen oder Beschreibung --------
    let fieldcount = this.additionalfields.length;
    //console.log("fieldcount: " + fieldcount);
    for(let i=0; i < (fieldcount); i++){
      let af = this.additionalfields[i];
     //console.log(af);
      if(af.name == "" ){
        return "Name der Zusatzfelder dürfen nicht leer sein.";
      }
      if(af.position <= 0){
        return "Position muss grösser als 0 sein."        
      }
      //-- check if position is unique ----------
      
      for(let j=0; j<(fieldcount); j++){
        //console.log("J:"+j);
        //console.log(this.additionalfields[j]);
        if(j==i){
          continue;
        }
        if(this.additionalfields[j].position == af.position){
          return "Position muss einzigartig sein, der Wert " +this.additionalfields[j].position+ " kommt mehrfach vor.";
        }
        if(this.additionalfields[j].name == af.name){
          return "Titel muss einzigartig sein, der Wert " +this.additionalfields[j].name+ " kommt mehrfach vor.";
        }
      }
    
    }

    return "";

  }
  
}



// WEBPACK FOOTER //
// ./src/components/additionalfields/additionalfields.ts